/* ================ Handle App Event To Appcelerator Layer ====================
  This Event Engine will mimic a WEB API request which returns a promise e.g. Axios.
  Just like Axios handleAppEvent will return a promise, which will be resolved by the Middleware.
  We will have diffenet cases for each type e.g. FETCH_DATA, INSERT_DATA, UPDATE_DATA, DELETE_DATA
 ===========================================
*/
/*eslint-disable*/
const Promise = require('bluebird');

export default function handleAppEvent(event, params) {
  switch (event) {
    case 'FETCH_MISC_DATA':
      return new Promise((resolve, reject) => {
        // Added the add event listener before the fireevent so that the event
        // can be added to be listened before,
        // incase its added after it will sometimes miss the fireevent from Appc Leads file.

        Ti.App.addEventListener('web: returnFetchMiscData', returnFetchMiscData); //eslint-disable-line
        Ti.App.fireEvent('app: fetchMiscData', { payload: params }); //eslint-disable-line
        function returnFetchMiscData(data) {
          if (data.payload.success) {
            Ti.App.removeEventListener('web: returnFetchMiscData', returnFetchMiscData); //eslint-disable-line
            resolve(data.payload.data);
          } else {
            Ti.App.removeEventListener('web: returnFetchMiscData', returnFetchMiscData); //eslint-disable-line
            reject(data.payload.reason);
          }
        }
      });
    case 'FETCH_DATA':
      return new Promise((resolve, reject) => {
        // Added the add event listener before the fireevent so that the event
        // can be added to be listened before,
        // incase its added after it will sometimes miss the fireevent from Appc Leads file.

        Ti.App.addEventListener('web: returnFetchData', returnFetchData); //eslint-disable-line
        Ti.App.fireEvent('app: fetchData', { payload: params }) //eslint-disable-line
        function returnFetchData(data) {
          if (data.payload.success) {
            Ti.App.removeEventListener('web: returnFetchData', returnFetchData); //eslint-disable-line
            resolve(data.payload.data);
          } else {
            Ti.App.removeEventListener('web: returnFetchData', returnFetchData); //eslint-disable-line
            reject(data.payload.reason);
          }
        }
      });
    case 'FETCH_LEAD_DATA':
      return new Promise((resolve, reject) => {
        // Added the add event listener before the fireevent so that the event
        // can be added to be listened before,
        // incase its added after it will sometimes miss the fireevent from Appc Leads file.
        Ti.App.addEventListener('web: returnFetchData', returnFetchData); //eslint-disable-line
        Ti.App.fireEvent('app: fetchLeadData', { payload: params }) //eslint-disable-line
        function returnFetchData(data) {
          if (data.payload.success) {
            Ti.App.removeEventListener('web: returnFetchData', returnFetchData); //eslint-disable-line
            resolve(data.payload.data);
          } else {
            Ti.App.removeEventListener('web: returnFetchData', returnFetchData); //eslint-disable-line
            reject(data.payload.data);
          }
        }
      });
    case 'FETCH_MANAGE_CAMPAIGN_DATA':
      return new Promise((resolve, reject) => {
        console.log('Fetching License event Engine');
        Ti.App.addEventListener('web: returnFetchManageCampaignData', returnFetchManageCampaignData); //eslint-disable-line
        Ti.App.fireEvent('app: fetchManageCampaignData', { payload: params }) //eslint-disable-line
        function returnFetchManageCampaignData(data) {
          if (data.payload.success) {
            Ti.App.removeEventListener('web: returnFetchManageCampaignData', returnFetchManageCampaignData); //eslint-disable-line
            resolve(data.payload.data);
          } else {
            Ti.App.removeEventListener('web: returnFetchManageCampaignData', returnFetchManageCampaignData); //eslint-disable-line
            reject(data.payload.reason);
          }
        }
      });
    case 'FETCH_CONTACT_DATA':
      return new Promise((resolve, reject) => {
        Ti.App.addEventListener('web: returnFetchContactData', returnFetchContactData); //eslint-disable-line
        Ti.App.fireEvent('app: fetchContactData', { payload: params }) //eslint-disable-line
        function returnFetchContactData(data) {
          if (data.payload.success) {
            Ti.App.removeEventListener('web: returnFetchContactData', returnFetchContactData); //eslint-disable-line
            resolve(data.payload.data);
          } else {
            Ti.App.removeEventListener('web: returnFetchContactData', returnFetchContactData); //eslint-disable-line
            reject(data.payload.reason);
          }
        }
      });
    case 'FETCH_MANAGE_LICENSE':
      return new Promise((resolve, reject) => {
        Ti.App.addEventListener('web: returnFetchLicense', returnFetchLicense); //eslint-disable-line
        Ti.App.fireEvent('app: fetchLicenseData', { payload: params }) //eslint-disable-line
        function returnFetchLicense(data) {
          if (data.payload.success) {
            Ti.App.removeEventListener('web: returnFetchLicense', returnFetchLicense); //eslint-disable-line
            resolve(data.payload.data);
          } else {
            Ti.App.removeEventListener('web: returnFetchLicense', returnFetchLicense); //eslint-disable-line
            reject(data.payload.reason);
          }
        }
      });
    case 'FETCH_OPEN_LEADS':
      return new Promise((resolve, reject) => {
        Ti.App.addEventListener('web: returnFetchOpenLeads', returnFetchOpenLeads); //eslint-disable-line
        Ti.App.fireEvent('app: fetchOpenLeadsData', { payload: params }) //eslint-disable-line
        function returnFetchOpenLeads(data) {
          if (data.payload.success) {
            console.log('data.payload.success==>', data.payload.success);
            Ti.App.removeEventListener('web: returnFetchOpenLeads', returnFetchOpenLeads); //eslint-disable-line
            resolve(data.payload.data);
          } else {
            Ti.App.removeEventListener('web: returnFetchOpenLeads', returnFetchOpenLeads); //eslint-disable-line
            reject(data.payload.reason);
          }
        }
      });  
    case 'FETCH_OPEN_SEARCH_LEAD_DATA':
      return new Promise((resolve, reject) => {
        Ti.App.addEventListener('web: returnFetchOpenSearchLeadsData', returnFetchOpenSearchLeadsData); //eslint-disable-line
        Ti.App.fireEvent('app: fetchOpenLeadSearchData', { payload: params }) //eslint-disable-line
        function returnFetchOpenSearchLeadsData(data) {
          if (data.payload.success) {
            console.log('data.payload.success==>', data.payload.success);
            Ti.App.removeEventListener('web: returnFetchOpenSearchLeadsData', returnFetchOpenSearchLeadsData); //eslint-disable-line
            resolve(data.payload.data);
          } else {
            Ti.App.removeEventListener('web: returnFetchOpenSearchLeadsData', returnFetchOpenSearchLeadsData); //eslint-disable-line
            reject(data.payload.reason);
          }
        }
      });  
    case 'INSERT_DATA':
      return new Promise((resolve, reject) => {
        Ti.App.addEventListener('web: returnConfirmation', returnConfirmation); //eslint-disable-line
        Ti.App.fireEvent('app: insertData', { payload: params }) //eslint-disable-line
        function returnConfirmation(data) {
          if (data.payload.success) {
            Ti.App.removeEventListener('web: returnConfirmation', returnConfirmation); //eslint-disable-line
            resolve(true);
          } else {
            Ti.App.removeEventListener('web: returnConfirmation', returnConfirmation); //eslint-disable-line
            reject(data.payload.reason);
          }
        }
      });
    case 'UPDATE_DATA':
      return new Promise((resolve, reject) => {
        Ti.App.addEventListener('web: returnUpdateConfirmation', returnUpdateConfirmation); //eslint-disable-line
        Ti.App.fireEvent('app: updateData', { payload: params }) //eslint-disable-line
        function returnUpdateConfirmation(data) {
          if (data.payload.success) {
            Ti.App.removeEventListener('web: returnUpdateConfirmation', returnUpdateConfirmation); //eslint-disable-line
            resolve(true);
          } else {
            Ti.App.removeEventListener('web: returnUpdateConfirmation', returnUpdateConfirmation); //eslint-disable-line
            reject(data.payload.reason);
          }
        }
      });
    case 'INSERT_CAL_DATA':
      return new Promise((resolve, reject) => {
        Ti.App.addEventListener('web: returnCalendarConfirmation', returnCalendarConfirmation); //eslint-disable-line
        Ti.App.fireEvent('app: insertToCalendar', { payload: params }) //eslint-disable-line
        function returnCalendarConfirmation(data) {
          if (data.payload.success) {
            Ti.App.removeEventListener('web: returnCalendarConfirmation', returnCalendarConfirmation); //eslint-disable-line
            resolve(data.payload);
          } else {
            Ti.App.removeEventListener('web: returnCalendarConfirmation', returnCalendarConfirmation); //eslint-disable-line
            reject(data.payload.reason);
          }
        }
      });
    case 'DELETE_PERSONAL_LEAD_DATA':
      return new Promise((resolve, reject) => {
        Ti.App.addEventListener('web: returnDeleteConfirmation', returnDeleteConfirmation); //eslint-disable-line
        Ti.App.fireEvent('app: deletePersonalData', { payload: params }) //eslint-disable-line
        function returnDeleteConfirmation(data) {
          if (data.payload.success) {
            Ti.App.removeEventListener('web: returnDeleteConfirmation', returnDeleteConfirmation); //eslint-disable-line
            resolve(true);
          } else {
            Ti.App.removeEventListener('web: returnDeleteConfirmation', returnDeleteConfirmation); //eslint-disable-line
            reject(data.payload.reason);
          }
        }
      });
    case 'UPDATE_MISC':
      return new Promise((resolve, reject) => {
        Ti.App.addEventListener('web: returnUpdateMiscConfirmation', returnUpdateMiscConfirmation); //eslint-disable-line
        Ti.App.fireEvent('app: updateMiscData', { payload: params }) //eslint-disable-line
        function returnUpdateMiscConfirmation(data) {
          if (data.payload.success) {
            Ti.App.removeEventListener('web: returnUpdateMiscConfirmation', returnUpdateMiscConfirmation); //eslint-disable-line
            resolve(true);
          } else {
            Ti.App.removeEventListener('web: returnUpdateMiscConfirmation', returnUpdateMiscConfirmation); //eslint-disable-line
            reject(data.payload.reason);
          }
        }
      });
    case 'UPDATE_DATA_DRAFT':
      return new Promise((resolve, reject) => {
        Ti.App.addEventListener('web: returnUpdateConfirmationDraft', returnUpdateConfirmation); //eslint-disable-line
        Ti.App.fireEvent('app: updateDataDraft', { payload: params }); //eslint-disable-line
        function returnUpdateConfirmation(data) {
          if (data.payload.success) {
            Ti.App.removeEventListener('web: returnUpdateConfirmationDraft', returnUpdateConfirmation); //eslint-disable-line
            resolve(true);
          } else {
            Ti.App.removeEventListener('web: returnUpdateConfirmationDraft', returnUpdateConfirmation); //eslint-disable-line
            reject(data.payload.reason);
          }
        }
      });
    default:
      return 'Event Not Handled';
  }
}

export const queue = [];
const debug = _debug('app:event');

// export const startPersistingData = () => {
//   setTimeout(persistFilter, 6000); //eslint-disable-line
// };

// const persistFilter = () => {
//   debug('persistFilter');
//   console.log('queue==>', queue);
//   if (queue.length <= 0) {
//     startPersistingData();
//     return;
//   }
//   handleAppEvent('UPDATE_MISC', queue[0])
//   .then(() => {
//     queue.shift();
//     startPersistingData();
//     return null;
//   })
//   .catch(() => {
//     queue.shift();
//     startPersistingData();
//     return null;
//   });
// };



// WEBPACK FOOTER //
// ./src/lib/event_engine.js